export default (file) => {
  const extension = file.name.split('.').pop().toLowerCase();
  let type = null;
  if (extension === 'geojson' || extension === 'json') {
    type = 'json';
  } else if (extension === 'kml') {
    type = 'kml';
  } else if (extension === 'gml') {
    type = 'gml';
  } else if (extension === 'csv') {
    type = 'csv';
  } else if (extension === 'zip') {
    type = 'zip';
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve({
        type,
        result: reader.result,
      });
    };
    reader.onerror = ($error) => reject($error);
    reader.readAsText(file);
  });
};
